import React, { useEffect, useState } from 'react';
const START_SECONDS = 23 * 3600 + 18 * 60 + 43;
function format(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(previous => previous <= 1 ? START_SECONDS : previous - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const units = [{
    value: Math.floor(remaining / 3600),
    label: 'Horas'
  }, {
    value: Math.floor(remaining % 3600 / 60),
    label: 'Min'
  }, {
    value: remaining % 60,
    label: 'Seg'
  }];
  return <div className="mt-6 text-center" data-id="element-28" data-mp="15dw78a5n58cg">
      <p className="font-display text-[10px] font-semibold uppercase tracking-[0.22em] text-gold" data-id="element-29" data-mp="15exv5f7r9pbl">
        Esta oferta expira en:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" role="timer" aria-live="off" data-id="element-30" data-mp="34oe4qj60ns3v">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-31" data-mp="1c0f7lgr1ekw4" data-mpi={index}>
            {index > 0 && <span className="pt-2 font-display text-xl text-cream-dim" data-id="element-32" data-mp="1c31fxilr54fe">:</span>}
            <div className="flex flex-col items-center" data-id="element-33" data-mp="1h12ze4n3b5re">
              <span className="flex h-12 w-12 items-center justify-center rounded-md border border-night-line bg-night-card font-display text-xl font-bold text-gold" data-id="element-34" data-mp="123ak9dlggjdq">
                {format(unit.value)}
              </span>
              <span className="mt-1 text-[9px] font-semibold uppercase tracking-[0.15em] text-cream-dim" data-id="element-35" data-mp="1ushjyfwnbf0k">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}